import * as React from 'react';
export const IcDayNight = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.34 7.76c.192.183.445.286.71.29a1 1 0 001-1 1.05 1.05 0 00-.29-.71l-.71-.7a1 1 0 00-.71-.3 1 1 0 00-.921 1.385 1 1 0 00.221.325l.7.71zM12 6a1 1 0 001-1V4a1 1 0 00-2 0v1a1 1 0 001 1zm-6 6a1 1 0 00-1-1H4a1 1 0 000 2h1a1 1 0 001-1zm11-3.95a1.05 1.05 0 00.71-.29l.7-.71a1 1 0 00.3-.71 1 1 0 00-1.385-.921A1 1 0 0017 5.64l-.71.7a1.05 1.05 0 00-.29.71 1 1 0 001 1zm3.76 3.24A1.001 1.001 0 0020 11h-1a1 1 0 000 2h1a1 1 0 00.71-1.71h.05zm-3.05 4.95A1.05 1.05 0 0017 16a1 1 0 00-1 1c.004.265.107.518.29.71l.71.7a1 1 0 00.71.3 1 1 0 00.921-1.385A1 1 0 0018.41 17l-.7-.76zM12 7a5 5 0 100 10 5 5 0 000-10zm0 8a3 3 0 01-.47-5.95A3.93 3.93 0 0011 11a4 4 0 002.38 3.65A2.94 2.94 0 0112 15zm-4.95 1a1.05 1.05 0 00-.71.29l-.7.71a1 1 0 00-.3.71 1 1 0 001.385.921 1 1 0 00.325-.221l.71-.7a1.05 1.05 0 00.29-.71 1 1 0 00-1-1zM12 18a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
